import { render } from "./AdminProducts.vue?vue&type=template&id=e4e4c986&scoped=true"
import script from "./AdminProducts.vue?vue&type=script&lang=js"
export * from "./AdminProducts.vue?vue&type=script&lang=js"

import "./AdminProducts.vue?vue&type=style&index=0&id=e4e4c986&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e4c986"]])

export default __exports__